import { createColumnHelper, HeaderContext } from '@tanstack/react-table';

import { Text } from '@chakra-ui/react';

import { GiftedEmployeesColumns } from 'app/constants/table';
import { EmployeesGiftedRow } from 'app/components/UI/Table/Table.types';
import formatNumber from 'app/utils/formatting';

function getGiftedEmployeesColumns() {
  const columnHelper = createColumnHelper<EmployeesGiftedRow>();

  const columns = Object.keys(GiftedEmployeesColumns).map((field) => {
    return columnHelper.accessor(field as keyof EmployeesGiftedRow, {
      cell: ({ getValue }) => {
        const value = getValue();

        switch (field as keyof EmployeesGiftedRow) {
          case 'fullName':
            return <Text>{value}</Text>;
          case 'email':
            return <Text>{value}</Text>;
          case 'points':
            return <Text>{formatNumber(Number(value))}</Text>;
          default:
            return value;
        }
      },
      header: GiftedEmployeesColumns[field as keyof typeof GiftedEmployeesColumns],
      enableSorting: false,
      meta: {
        getHeaderContext: (context: HeaderContext<EmployeesGiftedRow, unknown>) => {
          if (['points'].includes(context.header.id)) {
            return { style: { justifyContent: 'end' } };
          }
          return undefined;
        },
      },
    });
  });

  return columns;
}

export default getGiftedEmployeesColumns;
